import React from "react";

export function WinnersFooter() {
  return (
    <footer className="ws-footer">
      <div className="ws-footer-inner">
        <div className="ws-footer-top">
          <div className="ws-footer-brand">
            <h3>Winners</h3>
            <p>Modern property discovery across India — curated projects, transparent investments
              and future-ready communities.</p>
          </div>
          <div className="ws-footer-col">
            <h4>Explore</h4>
            <ul>
              <li><a>Properties</a></li>
              <li><a>Upcoming projects</a></li>
              <li><a>Cities</a></li>
              <li><a>Community</a></li>
            </ul>
          </div>
          <div className="ws-footer-col">
            <h4>Company</h4>
            <ul>
              <li><a>About</a></li>
              <li><a>Careers</a></li>
              <li><a>Blog</a></li>
              <li><a>Press</a></li>
            </ul>
          </div>
          <div className="ws-footer-col">
            <h4>Support</h4>
            <ul>
              <li><a>Help center</a></li>
              <li><a>Contact</a></li>
              <li><a>Privacy</a></li>
              <li><a>Terms</a></li>
            </ul>
          </div>
        </div>
        <div className="ws-footer-bottom">
          <span>© {new Date().getFullYear()} Winners Realty. All rights reserved.</span>
          {/* <span>Crafted with intent · India</span> */}
        </div>
      </div>
    </footer>
  );
}